import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://panel.linket.me/api/blog' }),
  tagTypes: ['blog'],

  endpoints: (builder) => ({
    getBlog: builder.query({
      query: (id) => `/bySiteAll/${id}`,
    }),
    getSiteBlog: builder.query({
      query: (id) => `/bySite/${id}`,
    }),
    getPostBlog: builder.query({
      query: (id) => `/post/${id}`,
    }),
  }),
})

export const { useGetBlogQuery , useGetSiteBlogQuery, useGetPostBlogQuery } = blogApi